import { render, staticRenderFns } from "./LegalDocInfoPanel.vue?vue&type=template&id=56d6e878&scoped=true&"
import script from "./LegalDocInfoPanel.js?vue&type=script&lang=js&"
export * from "./LegalDocInfoPanel.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d6e878",
  null
  
)

export default component.exports